import OverlayProps from "components/Overlay/OverlayProps";
import { useMainStore } from "stores/main.store";
import { onMounted, computed, ref } from "vue";
import FormInputGeneric from "components/FormElements/FormInputGeneric/FormInputGeneric.vue";
import FormInputCheckbox from "components/FormElements/FormInputCheckbox/FormInputCheckbox.vue";
import getLabelFromStore from "foundation/js/getLabelFromStore";
import nameValidator from "foundation/js/validators/nameValidator";
import emailValidator from "foundation/js/validators/emailValidator";

export default {
    name: "OverlayLeadGate",
    components: {
        FormInputGeneric,
        FormInputCheckbox
    },
    props: OverlayProps,
    setup(props) {
        const mainStore = useMainStore()
        
        const name = ref('')
        const title = ref('')
        const company = ref('')
        const email = ref('')
        const consent = ref(false)
        const displayErrors = ref(false)

        const downloadPath = computed(() => mainStore.leadGateData.downloadPath)
        const linkElement = computed(() => mainStore.leadGateData.linkElement)

        const getLabel = (labelKey) => getLabelFromStore({ labelKey: labelKey, collectionName: "OverlayLeadGate" })

        onMounted(() => {
            if (linkElement.value) {
                linkElement.value.setAttribute('aria-expanded', 'true')
            }
        })

        const validateForm = function() {
            const validators = [
                nameValidator(name.value),
                emailValidator(email.value),
                consent.value,
            ]

            return validators.every((validator) => validator)
        }

        const submitForm = function(e) {
            displayErrors.value = true

            const isFormValid = validateForm()
            if (!isFormValid) return

            mainStore.submitLeadGateForm({ 
                body: { 
                    name: name.value, 
                    title: title.value, 
                    company: company.value, 
                    email: email.value, 
                    consent: consent.value 
                } 
            })
            displayErrors.value = false

            setTimeout(() => {
                window.open(downloadPath.value, '_blank')
                props.closeTheModal()
            }, 100)
        }


        return {
            name,
            title,
            company,
            email,
            consent,
            displayErrors,
            nameValidator,
            emailValidator,
            getLabel,
            submitForm
        }
    }
}

